
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_45KNi5lrBO3iud17DtUuqsne5BIgOkk0cjpiA1jmOA7EMeta } from "C:/opt/yoien-cloud-frontend/pages/index.vue?macro=true";
import { default as loginGcbK_45UQS4hzumjM5a1rBAjdCMq9f0iGPzFr9jPjP2xAMeta } from "C:/opt/yoien-cloud-frontend/pages/login.vue?macro=true";
import { default as logoutXU5i2mnVbGRSVjIW1o0lFmTjx5qD05gJfV0Bxi2baigMeta } from "C:/opt/yoien-cloud-frontend/pages/logout.vue?macro=true";
import { default as _91status_93OyedPA3xrLpYyxhgZZ_DI1gk22Nc70bbz2aLMTShH_45QMeta } from "C:/opt/yoien-cloud-frontend/pages/error/[status].vue?macro=true";
import { default as select_45subjectJNB2q3rGK1gKUULmLcOX6pNCVg7BcLcwoyE5HNGd5FMMeta } from "C:/opt/yoien-cloud-frontend/pages/select-subject.vue?macro=true";
import { default as editukR8DEOkU7dyYHCtvqWcy_459k2_45_45aa8FSukxP3vtFakwMeta } from "C:/opt/yoien-cloud-frontend/pages/scene-manager/edit.vue?macro=true";
import { default as indexXpt_45mb34JUkNueYFZT97uDtHBnP3K7xLIA4Zfmycf2oMeta } from "C:/opt/yoien-cloud-frontend/pages/scene-manager/index.vue?macro=true";
import { default as indexdAVIOrz_45Z4LSjlovnOhDZpaBs_yON70hoN2wa_45E_of8Meta } from "C:/opt/yoien-cloud-frontend/pages/control-groups/index.vue?macro=true";
import { default as indexcvJpilY7bpvPVGC7qUqPB1NNb0JsSITAhPeQNLcOaXkMeta } from "C:/opt/yoien-cloud-frontend/pages/device-manager/index.vue?macro=true";
import { default as _91id_934sBISEFeBvh6Rasna7TPTUuoAN0FSr_45iFk8GF3ZCJpsMeta } from "C:/opt/yoien-cloud-frontend/pages/calendar-manager/[id].vue?macro=true";
import { default as indexwYfd4GHUQVwxQ0TDmjvJE0sPz3jsPHhBYRH0Odnd3ZwMeta } from "C:/opt/yoien-cloud-frontend/pages/content-manager/index.vue?macro=true";
import { default as _91id_936jj7YPAXbIT78HbuD638UjOUwhOhZ_45ONPx__eu9XbqQMeta } from "C:/opt/yoien-cloud-frontend/pages/schedule-manager/[id].vue?macro=true";
import { default as indexr0A6_45QNk92XGpi6TpJLzfJi3E7wvZ7aBY79aBjdEjrMMeta } from "C:/opt/yoien-cloud-frontend/pages/calendar-manager/index.vue?macro=true";
import { default as indexOP4pc1a8ZFXr3fsAPD22y7jzhSkQDxErZIEN208befwMeta } from "C:/opt/yoien-cloud-frontend/pages/data-transceiver/index.vue?macro=true";
import { default as registerIhS01jrVT0NyifjDP_451n9KLHBqhIYo0MNBpgeLC1QpwMeta } from "C:/opt/yoien-cloud-frontend/pages/scene-manager/register.vue?macro=true";
import { default as indexVKv2pVRpvODsiu9TbfzJ_Xwh5njx1crwo34hmmr0mMoMeta } from "C:/opt/yoien-cloud-frontend/pages/schedule-manager/index.vue?macro=true";
import { default as registeracwNLUYSw_MCMKvUEESFoSBOTAnvhgsWFfbRBDDq_Z0Meta } from "C:/opt/yoien-cloud-frontend/pages/control-groups/register.vue?macro=true";
import { default as composition1iu3t_hhSPenEKtoX9oKP769kxvuMZBNnvyLc2s_45HAsMeta } from "C:/opt/yoien-cloud-frontend/pages/scene-manager/composition.vue?macro=true";
import { default as registerNNY1_45fBirkb7W5Ci_8OYKHuNLprRTFbBXpFtjjq2ArIMeta } from "C:/opt/yoien-cloud-frontend/pages/schedule-manager/register.vue?macro=true";
import { default as indexr6GxzgmgIMGKVGwjIaEMKwgicYRga_sAGc0W_DxzmGUMeta } from "C:/opt/yoien-cloud-frontend/pages/system-setting/mail/index.vue?macro=true";
import { default as indexrytkeLi6498bav6wKPIZ5mlOwZIhwcwJqVUaDro7pVoMeta } from "C:/opt/yoien-cloud-frontend/pages/system-setting/popup/index.vue?macro=true";
import { default as error_45history6uy1FN9Gxhh40fLODsOIfdbN_iTe4_45NeMjo04gk9c6QMeta } from "C:/opt/yoien-cloud-frontend/pages/operation-status/error-history.vue?macro=true";
import { default as indexyVsHjOyLFO0gu_453YjKDESSAi4HNgzycfiD_EVb_XPKkMeta } from "C:/opt/yoien-cloud-frontend/pages/system-setting/information/index.vue?macro=true";
import { default as operation_45report2IlV_SeiNzpgjNZb9JA8Hjgsa7GOJnhfO_sbf99vJC0Meta } from "C:/opt/yoien-cloud-frontend/pages/operation-status/operation-report.vue?macro=true";
export default [
  {
    name: index_45KNi5lrBO3iud17DtUuqsne5BIgOkk0cjpiA1jmOA7EMeta?.name ?? "index",
    path: index_45KNi5lrBO3iud17DtUuqsne5BIgOkk0cjpiA1jmOA7EMeta?.path ?? "/",
    props: index_45KNi5lrBO3iud17DtUuqsne5BIgOkk0cjpiA1jmOA7EMeta?.props ?? false,
    meta: index_45KNi5lrBO3iud17DtUuqsne5BIgOkk0cjpiA1jmOA7EMeta || {},
    alias: index_45KNi5lrBO3iud17DtUuqsne5BIgOkk0cjpiA1jmOA7EMeta?.alias || [],
    redirect: index_45KNi5lrBO3iud17DtUuqsne5BIgOkk0cjpiA1jmOA7EMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/index.vue")
  },
  {
    name: loginGcbK_45UQS4hzumjM5a1rBAjdCMq9f0iGPzFr9jPjP2xAMeta?.name ?? "login",
    path: loginGcbK_45UQS4hzumjM5a1rBAjdCMq9f0iGPzFr9jPjP2xAMeta?.path ?? "/login",
    props: loginGcbK_45UQS4hzumjM5a1rBAjdCMq9f0iGPzFr9jPjP2xAMeta?.props ?? false,
    meta: loginGcbK_45UQS4hzumjM5a1rBAjdCMq9f0iGPzFr9jPjP2xAMeta || {},
    alias: loginGcbK_45UQS4hzumjM5a1rBAjdCMq9f0iGPzFr9jPjP2xAMeta?.alias || [],
    redirect: loginGcbK_45UQS4hzumjM5a1rBAjdCMq9f0iGPzFr9jPjP2xAMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/login.vue")
  },
  {
    name: logoutXU5i2mnVbGRSVjIW1o0lFmTjx5qD05gJfV0Bxi2baigMeta?.name ?? "logout",
    path: logoutXU5i2mnVbGRSVjIW1o0lFmTjx5qD05gJfV0Bxi2baigMeta?.path ?? "/logout",
    props: logoutXU5i2mnVbGRSVjIW1o0lFmTjx5qD05gJfV0Bxi2baigMeta?.props ?? false,
    meta: logoutXU5i2mnVbGRSVjIW1o0lFmTjx5qD05gJfV0Bxi2baigMeta || {},
    alias: logoutXU5i2mnVbGRSVjIW1o0lFmTjx5qD05gJfV0Bxi2baigMeta?.alias || [],
    redirect: logoutXU5i2mnVbGRSVjIW1o0lFmTjx5qD05gJfV0Bxi2baigMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/logout.vue")
  },
  {
    name: _91status_93OyedPA3xrLpYyxhgZZ_DI1gk22Nc70bbz2aLMTShH_45QMeta?.name ?? "error-status",
    path: _91status_93OyedPA3xrLpYyxhgZZ_DI1gk22Nc70bbz2aLMTShH_45QMeta?.path ?? "/error/:status()",
    props: _91status_93OyedPA3xrLpYyxhgZZ_DI1gk22Nc70bbz2aLMTShH_45QMeta?.props ?? false,
    meta: _91status_93OyedPA3xrLpYyxhgZZ_DI1gk22Nc70bbz2aLMTShH_45QMeta || {},
    alias: _91status_93OyedPA3xrLpYyxhgZZ_DI1gk22Nc70bbz2aLMTShH_45QMeta?.alias || [],
    redirect: _91status_93OyedPA3xrLpYyxhgZZ_DI1gk22Nc70bbz2aLMTShH_45QMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/error/[status].vue")
  },
  {
    name: select_45subjectJNB2q3rGK1gKUULmLcOX6pNCVg7BcLcwoyE5HNGd5FMMeta?.name ?? "select-subject",
    path: select_45subjectJNB2q3rGK1gKUULmLcOX6pNCVg7BcLcwoyE5HNGd5FMMeta?.path ?? "/select-subject",
    props: select_45subjectJNB2q3rGK1gKUULmLcOX6pNCVg7BcLcwoyE5HNGd5FMMeta?.props ?? false,
    meta: select_45subjectJNB2q3rGK1gKUULmLcOX6pNCVg7BcLcwoyE5HNGd5FMMeta || {},
    alias: select_45subjectJNB2q3rGK1gKUULmLcOX6pNCVg7BcLcwoyE5HNGd5FMMeta?.alias || [],
    redirect: select_45subjectJNB2q3rGK1gKUULmLcOX6pNCVg7BcLcwoyE5HNGd5FMMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/select-subject.vue")
  },
  {
    name: editukR8DEOkU7dyYHCtvqWcy_459k2_45_45aa8FSukxP3vtFakwMeta?.name ?? "scene-manager-edit",
    path: editukR8DEOkU7dyYHCtvqWcy_459k2_45_45aa8FSukxP3vtFakwMeta?.path ?? "/scene-manager/edit",
    props: editukR8DEOkU7dyYHCtvqWcy_459k2_45_45aa8FSukxP3vtFakwMeta?.props ?? false,
    meta: editukR8DEOkU7dyYHCtvqWcy_459k2_45_45aa8FSukxP3vtFakwMeta || {},
    alias: editukR8DEOkU7dyYHCtvqWcy_459k2_45_45aa8FSukxP3vtFakwMeta?.alias || [],
    redirect: editukR8DEOkU7dyYHCtvqWcy_459k2_45_45aa8FSukxP3vtFakwMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/scene-manager/edit.vue")
  },
  {
    name: indexXpt_45mb34JUkNueYFZT97uDtHBnP3K7xLIA4Zfmycf2oMeta?.name ?? "scene-manager",
    path: indexXpt_45mb34JUkNueYFZT97uDtHBnP3K7xLIA4Zfmycf2oMeta?.path ?? "/scene-manager",
    props: indexXpt_45mb34JUkNueYFZT97uDtHBnP3K7xLIA4Zfmycf2oMeta?.props ?? false,
    meta: indexXpt_45mb34JUkNueYFZT97uDtHBnP3K7xLIA4Zfmycf2oMeta || {},
    alias: indexXpt_45mb34JUkNueYFZT97uDtHBnP3K7xLIA4Zfmycf2oMeta?.alias || [],
    redirect: indexXpt_45mb34JUkNueYFZT97uDtHBnP3K7xLIA4Zfmycf2oMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/scene-manager/index.vue")
  },
  {
    name: indexdAVIOrz_45Z4LSjlovnOhDZpaBs_yON70hoN2wa_45E_of8Meta?.name ?? "control-groups",
    path: indexdAVIOrz_45Z4LSjlovnOhDZpaBs_yON70hoN2wa_45E_of8Meta?.path ?? "/control-groups",
    props: indexdAVIOrz_45Z4LSjlovnOhDZpaBs_yON70hoN2wa_45E_of8Meta?.props ?? false,
    meta: indexdAVIOrz_45Z4LSjlovnOhDZpaBs_yON70hoN2wa_45E_of8Meta || {},
    alias: indexdAVIOrz_45Z4LSjlovnOhDZpaBs_yON70hoN2wa_45E_of8Meta?.alias || [],
    redirect: indexdAVIOrz_45Z4LSjlovnOhDZpaBs_yON70hoN2wa_45E_of8Meta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/control-groups/index.vue")
  },
  {
    name: indexcvJpilY7bpvPVGC7qUqPB1NNb0JsSITAhPeQNLcOaXkMeta?.name ?? "device-manager",
    path: indexcvJpilY7bpvPVGC7qUqPB1NNb0JsSITAhPeQNLcOaXkMeta?.path ?? "/device-manager",
    props: indexcvJpilY7bpvPVGC7qUqPB1NNb0JsSITAhPeQNLcOaXkMeta?.props ?? false,
    meta: indexcvJpilY7bpvPVGC7qUqPB1NNb0JsSITAhPeQNLcOaXkMeta || {},
    alias: indexcvJpilY7bpvPVGC7qUqPB1NNb0JsSITAhPeQNLcOaXkMeta?.alias || [],
    redirect: indexcvJpilY7bpvPVGC7qUqPB1NNb0JsSITAhPeQNLcOaXkMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/device-manager/index.vue")
  },
  {
    name: _91id_934sBISEFeBvh6Rasna7TPTUuoAN0FSr_45iFk8GF3ZCJpsMeta?.name ?? "calendar-manager-id",
    path: _91id_934sBISEFeBvh6Rasna7TPTUuoAN0FSr_45iFk8GF3ZCJpsMeta?.path ?? "/calendar-manager/:id()",
    props: _91id_934sBISEFeBvh6Rasna7TPTUuoAN0FSr_45iFk8GF3ZCJpsMeta?.props ?? false,
    meta: _91id_934sBISEFeBvh6Rasna7TPTUuoAN0FSr_45iFk8GF3ZCJpsMeta || {},
    alias: _91id_934sBISEFeBvh6Rasna7TPTUuoAN0FSr_45iFk8GF3ZCJpsMeta?.alias || [],
    redirect: _91id_934sBISEFeBvh6Rasna7TPTUuoAN0FSr_45iFk8GF3ZCJpsMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/calendar-manager/[id].vue")
  },
  {
    name: indexwYfd4GHUQVwxQ0TDmjvJE0sPz3jsPHhBYRH0Odnd3ZwMeta?.name ?? "content-manager",
    path: indexwYfd4GHUQVwxQ0TDmjvJE0sPz3jsPHhBYRH0Odnd3ZwMeta?.path ?? "/content-manager",
    props: indexwYfd4GHUQVwxQ0TDmjvJE0sPz3jsPHhBYRH0Odnd3ZwMeta?.props ?? false,
    meta: indexwYfd4GHUQVwxQ0TDmjvJE0sPz3jsPHhBYRH0Odnd3ZwMeta || {},
    alias: indexwYfd4GHUQVwxQ0TDmjvJE0sPz3jsPHhBYRH0Odnd3ZwMeta?.alias || [],
    redirect: indexwYfd4GHUQVwxQ0TDmjvJE0sPz3jsPHhBYRH0Odnd3ZwMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/content-manager/index.vue")
  },
  {
    name: _91id_936jj7YPAXbIT78HbuD638UjOUwhOhZ_45ONPx__eu9XbqQMeta?.name ?? "schedule-manager-id",
    path: _91id_936jj7YPAXbIT78HbuD638UjOUwhOhZ_45ONPx__eu9XbqQMeta?.path ?? "/schedule-manager/:id()",
    props: _91id_936jj7YPAXbIT78HbuD638UjOUwhOhZ_45ONPx__eu9XbqQMeta?.props ?? false,
    meta: _91id_936jj7YPAXbIT78HbuD638UjOUwhOhZ_45ONPx__eu9XbqQMeta || {},
    alias: _91id_936jj7YPAXbIT78HbuD638UjOUwhOhZ_45ONPx__eu9XbqQMeta?.alias || [],
    redirect: _91id_936jj7YPAXbIT78HbuD638UjOUwhOhZ_45ONPx__eu9XbqQMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/schedule-manager/[id].vue")
  },
  {
    name: indexr0A6_45QNk92XGpi6TpJLzfJi3E7wvZ7aBY79aBjdEjrMMeta?.name ?? "calendar-manager",
    path: indexr0A6_45QNk92XGpi6TpJLzfJi3E7wvZ7aBY79aBjdEjrMMeta?.path ?? "/calendar-manager",
    props: indexr0A6_45QNk92XGpi6TpJLzfJi3E7wvZ7aBY79aBjdEjrMMeta?.props ?? false,
    meta: indexr0A6_45QNk92XGpi6TpJLzfJi3E7wvZ7aBY79aBjdEjrMMeta || {},
    alias: indexr0A6_45QNk92XGpi6TpJLzfJi3E7wvZ7aBY79aBjdEjrMMeta?.alias || [],
    redirect: indexr0A6_45QNk92XGpi6TpJLzfJi3E7wvZ7aBY79aBjdEjrMMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/calendar-manager/index.vue")
  },
  {
    name: indexOP4pc1a8ZFXr3fsAPD22y7jzhSkQDxErZIEN208befwMeta?.name ?? "data-transceiver",
    path: indexOP4pc1a8ZFXr3fsAPD22y7jzhSkQDxErZIEN208befwMeta?.path ?? "/data-transceiver",
    props: indexOP4pc1a8ZFXr3fsAPD22y7jzhSkQDxErZIEN208befwMeta?.props ?? false,
    meta: indexOP4pc1a8ZFXr3fsAPD22y7jzhSkQDxErZIEN208befwMeta || {},
    alias: indexOP4pc1a8ZFXr3fsAPD22y7jzhSkQDxErZIEN208befwMeta?.alias || [],
    redirect: indexOP4pc1a8ZFXr3fsAPD22y7jzhSkQDxErZIEN208befwMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/data-transceiver/index.vue")
  },
  {
    name: registerIhS01jrVT0NyifjDP_451n9KLHBqhIYo0MNBpgeLC1QpwMeta?.name ?? "scene-manager-register",
    path: registerIhS01jrVT0NyifjDP_451n9KLHBqhIYo0MNBpgeLC1QpwMeta?.path ?? "/scene-manager/register",
    props: registerIhS01jrVT0NyifjDP_451n9KLHBqhIYo0MNBpgeLC1QpwMeta?.props ?? false,
    meta: registerIhS01jrVT0NyifjDP_451n9KLHBqhIYo0MNBpgeLC1QpwMeta || {},
    alias: registerIhS01jrVT0NyifjDP_451n9KLHBqhIYo0MNBpgeLC1QpwMeta?.alias || [],
    redirect: registerIhS01jrVT0NyifjDP_451n9KLHBqhIYo0MNBpgeLC1QpwMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/scene-manager/register.vue")
  },
  {
    name: indexVKv2pVRpvODsiu9TbfzJ_Xwh5njx1crwo34hmmr0mMoMeta?.name ?? "schedule-manager",
    path: indexVKv2pVRpvODsiu9TbfzJ_Xwh5njx1crwo34hmmr0mMoMeta?.path ?? "/schedule-manager",
    props: indexVKv2pVRpvODsiu9TbfzJ_Xwh5njx1crwo34hmmr0mMoMeta?.props ?? false,
    meta: indexVKv2pVRpvODsiu9TbfzJ_Xwh5njx1crwo34hmmr0mMoMeta || {},
    alias: indexVKv2pVRpvODsiu9TbfzJ_Xwh5njx1crwo34hmmr0mMoMeta?.alias || [],
    redirect: indexVKv2pVRpvODsiu9TbfzJ_Xwh5njx1crwo34hmmr0mMoMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/schedule-manager/index.vue")
  },
  {
    name: registeracwNLUYSw_MCMKvUEESFoSBOTAnvhgsWFfbRBDDq_Z0Meta?.name ?? "control-groups-register",
    path: registeracwNLUYSw_MCMKvUEESFoSBOTAnvhgsWFfbRBDDq_Z0Meta?.path ?? "/control-groups/register",
    props: registeracwNLUYSw_MCMKvUEESFoSBOTAnvhgsWFfbRBDDq_Z0Meta?.props ?? false,
    meta: registeracwNLUYSw_MCMKvUEESFoSBOTAnvhgsWFfbRBDDq_Z0Meta || {},
    alias: registeracwNLUYSw_MCMKvUEESFoSBOTAnvhgsWFfbRBDDq_Z0Meta?.alias || [],
    redirect: registeracwNLUYSw_MCMKvUEESFoSBOTAnvhgsWFfbRBDDq_Z0Meta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/control-groups/register.vue")
  },
  {
    name: composition1iu3t_hhSPenEKtoX9oKP769kxvuMZBNnvyLc2s_45HAsMeta?.name ?? "scene-manager-composition",
    path: composition1iu3t_hhSPenEKtoX9oKP769kxvuMZBNnvyLc2s_45HAsMeta?.path ?? "/scene-manager/composition",
    props: composition1iu3t_hhSPenEKtoX9oKP769kxvuMZBNnvyLc2s_45HAsMeta?.props ?? false,
    meta: composition1iu3t_hhSPenEKtoX9oKP769kxvuMZBNnvyLc2s_45HAsMeta || {},
    alias: composition1iu3t_hhSPenEKtoX9oKP769kxvuMZBNnvyLc2s_45HAsMeta?.alias || [],
    redirect: composition1iu3t_hhSPenEKtoX9oKP769kxvuMZBNnvyLc2s_45HAsMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/scene-manager/composition.vue")
  },
  {
    name: registerNNY1_45fBirkb7W5Ci_8OYKHuNLprRTFbBXpFtjjq2ArIMeta?.name ?? "schedule-manager-register",
    path: registerNNY1_45fBirkb7W5Ci_8OYKHuNLprRTFbBXpFtjjq2ArIMeta?.path ?? "/schedule-manager/register",
    props: registerNNY1_45fBirkb7W5Ci_8OYKHuNLprRTFbBXpFtjjq2ArIMeta?.props ?? false,
    meta: registerNNY1_45fBirkb7W5Ci_8OYKHuNLprRTFbBXpFtjjq2ArIMeta || {},
    alias: registerNNY1_45fBirkb7W5Ci_8OYKHuNLprRTFbBXpFtjjq2ArIMeta?.alias || [],
    redirect: registerNNY1_45fBirkb7W5Ci_8OYKHuNLprRTFbBXpFtjjq2ArIMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/schedule-manager/register.vue")
  },
  {
    name: indexr6GxzgmgIMGKVGwjIaEMKwgicYRga_sAGc0W_DxzmGUMeta?.name ?? "system-setting-mail",
    path: indexr6GxzgmgIMGKVGwjIaEMKwgicYRga_sAGc0W_DxzmGUMeta?.path ?? "/system-setting/mail",
    props: indexr6GxzgmgIMGKVGwjIaEMKwgicYRga_sAGc0W_DxzmGUMeta?.props ?? false,
    meta: indexr6GxzgmgIMGKVGwjIaEMKwgicYRga_sAGc0W_DxzmGUMeta || {},
    alias: indexr6GxzgmgIMGKVGwjIaEMKwgicYRga_sAGc0W_DxzmGUMeta?.alias || [],
    redirect: indexr6GxzgmgIMGKVGwjIaEMKwgicYRga_sAGc0W_DxzmGUMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/system-setting/mail/index.vue")
  },
  {
    name: indexrytkeLi6498bav6wKPIZ5mlOwZIhwcwJqVUaDro7pVoMeta?.name ?? "system-setting-popup",
    path: indexrytkeLi6498bav6wKPIZ5mlOwZIhwcwJqVUaDro7pVoMeta?.path ?? "/system-setting/popup",
    props: indexrytkeLi6498bav6wKPIZ5mlOwZIhwcwJqVUaDro7pVoMeta?.props ?? false,
    meta: indexrytkeLi6498bav6wKPIZ5mlOwZIhwcwJqVUaDro7pVoMeta || {},
    alias: indexrytkeLi6498bav6wKPIZ5mlOwZIhwcwJqVUaDro7pVoMeta?.alias || [],
    redirect: indexrytkeLi6498bav6wKPIZ5mlOwZIhwcwJqVUaDro7pVoMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/system-setting/popup/index.vue")
  },
  {
    name: error_45history6uy1FN9Gxhh40fLODsOIfdbN_iTe4_45NeMjo04gk9c6QMeta?.name ?? "operation-status-error-history",
    path: error_45history6uy1FN9Gxhh40fLODsOIfdbN_iTe4_45NeMjo04gk9c6QMeta?.path ?? "/operation-status/error-history",
    props: error_45history6uy1FN9Gxhh40fLODsOIfdbN_iTe4_45NeMjo04gk9c6QMeta?.props ?? false,
    meta: error_45history6uy1FN9Gxhh40fLODsOIfdbN_iTe4_45NeMjo04gk9c6QMeta || {},
    alias: error_45history6uy1FN9Gxhh40fLODsOIfdbN_iTe4_45NeMjo04gk9c6QMeta?.alias || [],
    redirect: error_45history6uy1FN9Gxhh40fLODsOIfdbN_iTe4_45NeMjo04gk9c6QMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/operation-status/error-history.vue")
  },
  {
    name: indexyVsHjOyLFO0gu_453YjKDESSAi4HNgzycfiD_EVb_XPKkMeta?.name ?? "system-setting-information",
    path: indexyVsHjOyLFO0gu_453YjKDESSAi4HNgzycfiD_EVb_XPKkMeta?.path ?? "/system-setting/information",
    props: indexyVsHjOyLFO0gu_453YjKDESSAi4HNgzycfiD_EVb_XPKkMeta?.props ?? false,
    meta: indexyVsHjOyLFO0gu_453YjKDESSAi4HNgzycfiD_EVb_XPKkMeta || {},
    alias: indexyVsHjOyLFO0gu_453YjKDESSAi4HNgzycfiD_EVb_XPKkMeta?.alias || [],
    redirect: indexyVsHjOyLFO0gu_453YjKDESSAi4HNgzycfiD_EVb_XPKkMeta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/system-setting/information/index.vue")
  },
  {
    name: operation_45report2IlV_SeiNzpgjNZb9JA8Hjgsa7GOJnhfO_sbf99vJC0Meta?.name ?? "operation-status-operation-report",
    path: operation_45report2IlV_SeiNzpgjNZb9JA8Hjgsa7GOJnhfO_sbf99vJC0Meta?.path ?? "/operation-status/operation-report",
    props: operation_45report2IlV_SeiNzpgjNZb9JA8Hjgsa7GOJnhfO_sbf99vJC0Meta?.props ?? false,
    meta: operation_45report2IlV_SeiNzpgjNZb9JA8Hjgsa7GOJnhfO_sbf99vJC0Meta || {},
    alias: operation_45report2IlV_SeiNzpgjNZb9JA8Hjgsa7GOJnhfO_sbf99vJC0Meta?.alias || [],
    redirect: operation_45report2IlV_SeiNzpgjNZb9JA8Hjgsa7GOJnhfO_sbf99vJC0Meta?.redirect,
    component: () => import("C:/opt/yoien-cloud-frontend/pages/operation-status/operation-report.vue")
  }
]